























import { Component, Vue, Watch } from "vue-property-decorator";
import { getters as gettersGlobal } from "@/observables/Global";
@Component({})
export default class extends Vue {
  /* Data */
  tableDataset: Summary.TableDataset[] = [
    {
      name: "min",
      key: "min",
      value: 0
    },
    {
      name: "first-quartile",
      key: "q1",
      value: 0
    },
    {
      name: "median",
      key: "q2",
      value: 0
    },
    {
      name: "average",
      key: "avg",
      value: 0
    },
    {
      name: "third-quartile",
      key: "q3",
      value: 0
    },
    {
      name: "max",
      key: "max",
      value: 0
    },
    {
      name: "standard-deviation",
      key: "dp",
      value: 0
    }
  ];

  /* Computed */
  get measure(): string {
    return gettersGlobal.getMeasure();
  }

  get summaryData(): Summary.Data {
    return gettersGlobal.getSummaryData();
  }

  /* Hooks */
  mounted() {
    this.normalizeSummaryData();
  }

  /* Methods */
  normalizeSummaryData() {
    const data = this.summaryData;
    /* Faz a distrituição de valores vindas de "gettersGlobal.getSummaryData()" para seus
    respectivos values do data "tableDataset" utilizando o atributo key. */
    this.tableDataset.forEach((e: Summary.TableDataset) => {
      e.value = parseFloat(data[e.key].toFixed(2));
    });
    return this.tableDataset;
  }

  /* Watch */
  @Watch("summaryData", { deep: true }) onSummaryData() {
    /* Caso haja quaisquer alteração nos dados de SummaryData será novamente carregado os valores para "tableDataset" */
    this.normalizeSummaryData();
  }
}
